import { action, observable, makeObservable, runInAction } from "mobx";

import {
  OrderProductsVariantRequestSchema,
  OrderProductsVariantSchema,
} from "../../../models/Order/OrderProductsVariant";
import OrderProductsVariantsAPI from "../api/OrderProductsVariantsAPI";

export class OrderProductsVariantsStore {
  variants: OrderProductsVariantSchema[];
  variantsAPI: OrderProductsVariantsAPI;

  constructor() {
    this.variants = [];
    this.variantsAPI = new OrderProductsVariantsAPI();

    makeObservable(this, {
      variants: observable,
      addVariant: action,
      updateVariant: action,
      deleteVariant: action,
      fetchVariantsByOrderIdAndProductId: action,
    });
  }

  addVariant = async (
    orderId: number,
    variant: OrderProductsVariantRequestSchema,
  ) => {
    try {
      const updated_id = (await this.variantsAPI.addVariant(
        orderId,
        variant,
      )) as number | null | undefined;

      if (updated_id) {
        const newVariant: OrderProductsVariantSchema = {
          id: updated_id,
          order_id: orderId,
          product_id: variant.product_id,
          sku: variant.sku,
          quantity: variant.quantity,
          title: variant.sku,
        };
        runInAction(() => {
          this.variants.push(newVariant);
        });
      }
    } catch (error: any) {
      throw error;
    }
  };

  updateVariant = async (
    orderId: number,
    variantId: number,
    variant: OrderProductsVariantRequestSchema,
  ) => {
    try {
      const updated_id = (await this.variantsAPI.updateVariant(
        orderId,
        variantId,
        variant,
      )) as number | null | undefined;

      if (updated_id) {
        const updatedVariant: OrderProductsVariantSchema = {
          id: updated_id,
          order_id: orderId,
          product_id: variant.product_id,
          sku: variant.sku,
          quantity: variant.quantity,
          title:
            this.variants.find((v) => v.id === variantId)?.title || variant.sku,
        };

        const index = this.variants.findIndex((v) => v.id === variantId);
        runInAction(() => {
          if (index !== -1) {
            this.variants[index] = {
              ...this.variants[index],
              ...updatedVariant,
            };
          } else {
            this.variants.push(updatedVariant);
          }
        });
      }
    } catch (error: any) {
      throw error;
    }
  };

  deleteVariant = async (orderId: number, variantId: number) => {
    try {
      await this.variantsAPI.deleteVariant(orderId, variantId);
      runInAction(() => {
        this.variants = this.variants.filter(
          (variant) => variant.id !== variantId,
        );
      });
    } catch (error: any) {
      throw error;
    }
  };

  fetchVariantsByOrderIdAndProductId = async (
    orderId: number,
    productId: number,
    addPrQuantity: boolean = false,
  ) => {
    try {
      const variants = (await this.variantsAPI.fetchVariants(
        orderId,
        productId,
        addPrQuantity,
      )) as OrderProductsVariantSchema[] | null | undefined;
      runInAction(() => {
        this.variants = variants || [];
      });
    } catch (error: any) {
      throw error;
    }
  };
}
